import { useI18nContext } from '@/i18n/i18n-react';
import { Activity, Bell, Download, ShoppingBag } from 'lucide-react';
import { DeltaBadge } from '@/components/metrics/delta-badge';
import { MetricCard } from '@/components/metric-card';
import { KpiCarousel } from '@/components/metrics/kpi-carousel';
import type { UsersMetricsGridProps } from '@/components/metrics/metric-sections.types';
import { formatIsoDateMedium } from '@/components/metrics/formatters';

export function UsersMetricsGrid({
  userMetrics,
  isLoadingUserMetrics,
  isLoadingDataSufficiency,
  dateFilterLabel,
  activeUsersSufficiency,
  downloadsDelta,
  comparison,
}: UsersMetricsGridProps) {
  const { LL, locale } = useI18nContext();

  const notifications = userMetrics?.usersWithEnabledNotifications;
  const converted = userMetrics?.convertedDownloads;
  const notificationsAtDate = notifications?.atDate?.trim();
  const notificationsDescription = notificationsAtDate
    ? formatIsoDateMedium(notificationsAtDate, locale)
    : dateFilterLabel;

  return (
    <KpiCarousel desktopClassName="grid gap-4 md:grid-cols-2 xl:grid-cols-4">
      {/* <MetricCard
        title={LL.metricsPage.downloads.title()}
        value={userMetrics?.downloads ?? '--'}
        icon={<Download className="h-6 w-6" />}
        description={dateFilterLabel}
        isLoading={isLoadingUserMetrics}
        helpKey="downloads"
      /> */}
      {/* <MetricCard
        title={LL.metricsPage.totalDownloads.title()}
        value={userMetrics?.totalDownloads ?? '--'}
        icon={<Download className="h-6 w-6" />}
        description={'Desde o início'}
        isLoading={isLoadingUserMetrics}
        helpKey="totalDownloads"
      /> */}
      {/* <MetricCard
        title={LL.metricsPage.convertedDownloads.title()}
        value={converted?.count ?? '--'}
        secondaryAffix={convertedPercentAffix ?? undefined}
        icon={<Percent className="h-6 w-6" />}
        description={dateFilterLabel}
        isLoading={isLoadingUserMetrics}
        helpKey="convertedDownloads"
      /> */}
      <MetricCard
        title={LL.metricsPage.usersWithEnabledNotifications.title()}
        value={notifications?.count ?? '--'}
        icon={<Bell className="h-6 w-6" />}
        description={notificationsDescription}
        isLoading={isLoadingUserMetrics}
        helpKey="usersWithEnabledNotifications"
      />
      <MetricCard
        title={LL.metricsPage.activeUsers.title()}
        value={userMetrics?.activeUsers ?? '--'}
        icon={<Activity className="h-6 w-6" />}
        description={dateFilterLabel}
        isLoading={isLoadingUserMetrics}
        isLoadingDataSufficiency={isLoadingDataSufficiency}
        helpKey="activeUsers"
        dataSufficiency={activeUsersSufficiency}
      />
      <MetricCard
        title={LL.metricsPage.downloads.title()}
        value={userMetrics?.downloads ?? '--'}
        icon={<Download className="h-6 w-6" />}
        description={dateFilterLabel}
        isLoading={isLoadingUserMetrics}
        helpKey="downloads"
        delta={
          downloadsDelta ? (
            <DeltaBadge delta={downloadsDelta} comparison={comparison} />
          ) : undefined
        }
      />
      {/* ANLT-06: `convertedDownloads.percentage` is a 0–1 ratio. */}
      <MetricCard
        title={LL.metricsPage.usersTab.converted()}
        value={
          converted
            ? new Intl.NumberFormat(locale, {
                style: 'percent',
                minimumFractionDigits: 1,
                maximumFractionDigits: 1,
              }).format(converted.percentage)
            : '--'
        }
        icon={<ShoppingBag className="h-6 w-6" />}
        description={
          converted && userMetrics
            ? LL.metricsPage.usersTab.convertedDescription({
                count: new Intl.NumberFormat(locale).format(converted.count),
                downloads: new Intl.NumberFormat(locale).format(
                  userMetrics.downloads
                ),
              })
            : dateFilterLabel
        }
        isLoading={isLoadingUserMetrics}
        helpKey="convertedDownloads"
      />
    </KpiCarousel>
  );
}
